// @flow

import React, { Component } from 'react';
import { UIContextPropType } from './UIProvider';
import type { UIProviderContext } from './UIProvider';

export default class Logo extends Component<*> {
  context: UIProviderContext;

  static contextTypes = {
    dbui: UIContextPropType,
  };

  render() {
    return (
      <img
        alt={this.context.dbui.appName}
        src={this.context.dbui.logo}
        {...this.props}
      />
    );
  }
}
